/*
 * @Author: your name
 * @Date: 2019-10-31 15:01:26
 * @LastEditTime: 2020-08-13 10:53:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/router/index.js
 */ 
import VueRouter from 'vue-router'

//导入路由列表
import routes from './routes'

//创建路由实例
const router = new VueRouter({
  routes
})

let hasInit = false
//全局路由器钩子，跳转之前
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  let { name: toName } = to

  hasInit = toName === 'xlEntry' ? true : hasInit;

  if (!hasInit) {
    const store = router.app && router.app.$options && router.app.$options.store
    if (store) {
      try {
        await store.dispatch('global/init_appParam', { route: to })
        await store.dispatch('global/common_config')
      } catch (err) {
        console.error('[router.beforeEach] pre-enter error', err)
      }
    }
    hasInit = true;
  }
  next()
})

//初始化
function install(Vue) {
  //使用VueRouter插件
  Vue.use(VueRouter)
}

export default {
  install,
  router//把router实例传递出去，用于Vue实例化方法的参数
}



// WEBPACK FOOTER //
// ./src/router/index.js